import React, { useEffect, useState } from 'react'
import { Link, NavLink, useLocation } from 'react-router-dom'
import logoWhite from '../resources/speed-lab-logo-dark.svg'
import logoColor from '../resources/speed-lab-logo-light.svg'

const links = [
  { to: '/', label: 'Home', exact: true },
  { to: '/publications', label: 'Publications' },
  { to: '/news', label: 'News' },
  { to: '/team', label: 'Team' },
  { to: '/resources', label: 'Resources' },
]

const Header = () => {
  const { pathname } = useLocation()
  const [scrolled, setScrolled] = useState(false)
  const [open, setOpen] = useState(false)

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24)
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  useEffect(() => setOpen(false), [pathname])

  // The home page and every page hero sit on the navy background, so the
  // header stays light-on-dark until the visitor scrolls past it.
  const solid = scrolled || open

  return (
    <header className={`site-header ${solid ? 'is-solid' : ''}`}>
      <div className='site-header__inner'>
        <Link to='/' className='site-header__brand'>
          <img
            src={solid ? logoColor : logoWhite}
            alt='SPEED Lab: Secure Prediction, Edge AI, and LLM Lab'
          />
        </Link>

        <nav className={`site-nav ${open ? 'is-open' : ''}`}>
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              exact={l.exact}
              className='site-nav__link'
              activeClassName='is-active'
            >
              {l.label}
            </NavLink>
          ))}
          <a className='site-nav__cta' href='#contact'>
            Contact
          </a>
        </nav>

        <button
          className={`site-header__toggle ${open ? 'is-open' : ''}`}
          aria-label='Toggle navigation'
          aria-expanded={open}
          onClick={() => setOpen(!open)}
        >
          <span />
          <span />
        </button>
      </div>
    </header>
  )
}

export default Header
